import { App } from 'vue';
import vColorDirective from './src/color.ts';
declare const _default: {
    install: (app: App) => void;
};
export default _default;
export { vColorDirective as vColor };
